<template>
    <div>
      <!-- <v-btn to="/facturacion">FACTURACION</v-btn> -->
      <v-data-table
        :headers="headers"
        :items="getAllItems"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:top >
          <v-toolbar flat color="white" >
            <v-toolbar-title>{{title}}</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            ></v-divider>
            <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar..."
            single-line
            hide-details
          ></v-text-field>
           <v-btn color="green" small outlined @click="descargarExcel"><v-icon color="green">mdi-microsoft-excel</v-icon></v-btn>
           <v-btn color="red" class="ml-1" small outlined @click="descargarPdf"><v-icon color="red">mdi-file-pdf-box</v-icon></v-btn>
            <v-spacer></v-spacer>   
            
              <v-autocomplete  :items="tipodocumentos"   
                    class="mr-3" hide-details v-model="tipodoc"
                     hide-selected outlined dense
                     @change="filtrarDocumentos"
                      label="Seleccione Comprobante"></v-autocomplete>

            <v-btn color="indigo" class="mr-3" @click="initialize">
              <v-icon color="white">mdi-file-restore</v-icon>
             </v-btn>

            <v-btn color="indigo" class="mr-5" @click="dialog=true" dark> 
                Filtrar <v-icon color="white">mdi-calendar-month</v-icon>
             </v-btn>
                   
          </v-toolbar>
        </template>
         <template v-slot:[`item.fecha`]="{ item }">
          {{ item.fecha | formatdate}}
        </template>
        
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon class="mr-1 mdi-24px" @click="printDoc(item)" color="blue">mdi-printer</v-icon>

          <!-- <v-icon class="mr-1 mdi-24px" @click="printPDF(item)" color="blue">mdi-printer</v-icon> -->
          <v-icon class="mr-1 mdi-24px" @click="enviarCorreo(item)"   color="orange" :disabled="item.idpersona.email.length<1">mdi-email</v-icon>
          <v-icon class="mr-1 mdi-24px" @click="duplicarDetalleFac(item)"   color="green" >mdi-content-duplicate</v-icon>
        

          <v-icon class="mr-1 mdi-24px" @click="anularFactura(item)" v-if="item.documento!=='Proforma'" color="red" :disabled="item.estado =='Anulada'">mdi-close-circle-outline</v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Recargar</v-btn>
        </template>
      </v-data-table>
      <!-- Modal para ventas por Fecha -->
      <v-dialog v-model="dialog" width="500">
       <VentasDialog :fechas="filtrar"  @ventasporfecha="getVentasPorFecha"/>
      </v-dialog>

      <v-dialog v-model="dialogSizePaper" width="500">
       <TamanioDocumento :documento="documento"  @opendialog="opendialog"/>
      </v-dialog>
  </div>
</template>

<script>

import axios from 'axios'
import Swal from 'sweetalert2'
import dayjs from 'dayjs'
import {mapGetters} from 'vuex'
import anularFel from '@/utils/anularFel'
import {json2excel} from 'js2excel';
import VentasDialog from './VentasDialog.vue'
import {setStorageCarrito} from "../POS/utils/localstorage";
import TamanioDocumento from './TamanioDocumento.vue'
export default {
  components:{
    VentasDialog,
    TamanioDocumento
  },
     data: () => ({
      dialog:false,
      dialogSizePaper:false,
      filtrar:{
        idestablecimiento:1,
        fechainicio:dayjs().format('YYYY-MM-DD'),
        fechafin:dayjs().format('YYYY-MM-DD'),
        documento:"*"
      },
      title:'DOCUMENTOS GENERADOS',
      tipodoc:"Mostrar Todos",
      tipodocumentos:["Facturas Electrónicas", "Recibos","Proformas","Envios","Mostrar Todos"],
      documento:{},
      search:'',
      headers: [       
        { text: 'Fecha', value: 'fecha'},
        { text: 'Nit',align: 'left', value: 'idpersona.nit'},      
        { text: 'Cliente',align: 'left', value: 'cliente',width: '50%'},      
        { text: 'Establecimiento',align: 'left', value: 'idestablecimiento.nombrecomercial'},      
        { text: 'Serie',align: 'left', value: 'serie',width: '10%' },      
        { text: 'Numero',align: 'center', value: 'numero'},        
        { text: 'Documento',align: 'center', value: 'documento'},   
        { text: 'Total Factura',align: 'center', value: 'total'},      
        { text: 'Estado',align: 'center', value: 'estado' },
        { text: 'Opciones',align: 'center', value: 'actions', sortable: false,width:'150px' },
      ],
    }),

    async created () {
      await this.initialize()
    },
    computed: {
      ...mapGetters(['getTokenUser','getUrlApi','getUrlPdf']),
      getAllItems () {
        return this.$store.getters.getAllVentas
      },
      getEstablecimientos(){
      return this.$store.getters.getEstablecimientosActivas
      }
    },
    methods: {
      async initialize () {
       await  this.$store.dispatch('setAllVentas')       
      }, 
      async getVentasPorFecha(fechas){
        this.dialog = false
        this.filtrar.fechainicio = dayjs(fechas.fechainicio).startOf('day').format('YYYY-MM-DD')
        this.filtrar.fechafin = dayjs(fechas.fechafin).endOf('day').format('YYYY-MM-DD')
      
        const params = `idestablecimiento=${this.filtrar.idestablecimiento}&fechainicio=${this.filtrar.fechainicio} 00:01:00&fechafin=${this.filtrar.fechafin} 23:59:50&documento=${fechas.documento}`
        await  this.$store.dispatch('setVentasPorFecha',params)
       
      },
      anularFactura(item) {       
         Swal.fire({
          title: `Anular ${item.documento}` ,
          text:'Escriba el motivo de la anulación',
          input: 'text',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, Anular!',
          cancelButtonText: 'Cancelar!'
        }).then((result) => {
          if (result.isConfirmed) {   

            if(item.documento==="Envios")this.putFactura(item);
            if(item.documento==="Recibo")this.putFactura(item);

            if(item.documento==="Factura Electrónica"){
              const xmlAnularFel = anularFel(item,result.value)
              this.anularDTE(xmlAnularFel,item)  
            }
  
           
           
          }
        })
                 
      },
      anularDTE(xmldte,item){
        const data = {nit:item.idestablecimiento.nit,xmldte,token:item.idestablecimiento.token}

        axios.post(`${this.getUrlApi}/digifact/anulardte`,data).then(res=>{
          
              if(res.data.Codigo==1){
                this.putFactura(item);
              }else{
                this.errorSwal(res.data.Mensaje);
              }
        }).catch((err)=>{this.errorSwal('No pudo Anularse el documento'),console.log(err)})
      },
      async duplicarDetalleFac(item){
        const { data } = await axios.get(`${this.getUrlApi}/facturadetalles/${item.idfactura}`,this.getTokenUser);
        setStorageCarrito(data)
        this.$router.push('/puntodeventa')
      },

      async putFactura(item){
        console.log(item)
        await axios.put(`${this.$store.getters.getUrlApi}/facturas/anularventa/${parseInt(item.idfactura)}/${parseInt(item.idestablecimiento.idestablecimiento)}`,{},this.getTokenUser).then(()=>{      
              this.alertDone('Documento Anulado')
              this.initialize()          
        }).catch(()=>{this.errorSwal('Error al anular el documento') })
      },     
      opendialog(){
        this.dialogSizePaper=!this.dialogSizePaper;
      },   
      async printPDF(item){
        this.documento = item;
        this.dialogSizePaper=true;
 
      },
      async printDoc(item){
        this.documento = item; /// Este es solo para el TICKET
        this.dialogSizePaper=true;
        await this.$store.dispatch('setdatatoprint',item)  
        //this.$router.push('/documentos/factura/mediumletter')
      },
      filtrarDocumentos(){
        this.$store.dispatch("filtrarArchivos",this.tipodoc)
      },
      async enviarCorreo(item){
        
        let datos = {...item}
        datos.size = 'fcletter'
         await this.$store.dispatch("generarPdf",datos)
        if(!item.idpersona.email){
          Swal.fire('Email Vacio','La persona no tiene correo registrado','error')
        }else{
          
        
         this.$store.dispatch("enviarCorreo",item)
        }
      },
      descargarExcel(){
        const elementos = []
        this.getAllItems.map(function(item) {         
          item.total = parseFloat(item.total)
          item.descuento = parseFloat(item.descuento)
          elementos.push(item)
        })

        const data = elementos
        try {
            json2excel({
                data,
                name: 'Reporte_Ventas',
                formateDate: 'yyyy/mm/dd'
            });
        } catch (e) {
            console.error('export error');
        }
      },
      async descargarPdf(){

        const datos = this.getAllItems.length>0?this.getAllItems:[];
        const titulo = 'Reporte de Ventas'
        const fechas = this.filtrar
       
        try {
          await axios.post(`${this.getUrlPdf}/ventas/`,{datos,titulo,fechas})
          window.open( `${this.getUrlPdf}/assets/informe.pdf`,"blank")
        } catch (error) {
          console.log(error)
        }

      },
      //Notificaciones Swal
      alertDone(message){
        Swal.fire({
          icon: 'success',
          title: message,
          showConfirmButton: false,
          timer: 1500
        })
      },
      errorSwal(message){
        Swal.fire({
          icon: 'error',
          title: message,        
        })
      }
    }
    
}
</script>
